/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dashboard_V2_Model_BreakdownInputs */



/**
* | output |
* | --- |
* | "Model breakdown" |
*
* @param {Dashboard_V2_Model_BreakdownInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const dashboard_v2_model_breakdown = /** @type {((inputs?: Dashboard_V2_Model_BreakdownInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dashboard_V2_Model_BreakdownInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Modellaufschlüsselung")
	return /** @type {LocalizedString} */ ("Model breakdown")
});